module.exports = __webpack_public_path__ + "img/price-mr.3823737c.png";